import { GitHubIcon } from '@backstage/core-components';
import { IconLink } from './IconLink';
import { buildGitHubUrl } from '@appfolio/backstage-plugin-utils-common';

export const GitHubLink = (props: { pathQuery: string; text: string }) => {
  const { pathQuery, text } = props;
  return (
    <IconLink Icon={GitHubIcon} to={buildGitHubUrl(pathQuery)} text={text} />
  );
};
